/**
 * @generated SignedSource<<a9b926b2447ba985b7c410130e2e7003>>
 * @relayHash b9ad0fa5b6a7f25b77f293333308cfed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 79c53268cc9a7d7758ab9786e27d5d6123c05a0621a6e2f9c152ab56712e835c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggDirectoryViewTableQuery$variables = {
  includeGoals: boolean;
  includeProjects: boolean;
  q?: string | null;
  scopeId: string;
};
export type AggDirectoryViewTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AggDirectoryViewPaginationQuery">;
};
export type AggDirectoryViewTableQuery = {
  response: AggDirectoryViewTableQuery$data;
  variables: AggDirectoryViewTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeGoals"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeProjects"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v4 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "q"
},
v5 = {
  "kind": "Variable",
  "name": "scopeId",
  "variableName": "scopeId"
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggDirectoryViewTableQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeGoals",
            "variableName": "includeGoals"
          },
          {
            "kind": "Variable",
            "name": "includeProjects",
            "variableName": "includeProjects"
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AggDirectoryViewPaginationQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggDirectoryViewTableQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "largeAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                          }
                        ],
                        "concreteType": "TeamMemberConnectionV2",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamMemberEdgeV2",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMemberV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v7/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v8/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "members(first:100)"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "concreteType": "TeamType",
                        "kind": "LinkedField",
                        "name": "type",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "verified"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "concreteType": "TeamHierarchy",
                        "kind": "LinkedField",
                        "name": "hierarchy",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 25
                              }
                            ],
                            "concreteType": "TeamChildrenConnection",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamChildrenEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "children(first:25)"
                          }
                        ]
                      },
                      {
                        "condition": "includeGoals",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TeamGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TeamGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "goal",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v10/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalIcon",
                                            "kind": "LinkedField",
                                            "name": "icon",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "appearance"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeProjects",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TeamProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TeamProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v10/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "isPrivate"
                                          },
                                          {
                                            "concreteType": "TownsquareIconURIs",
                                            "kind": "LinkedField",
                                            "name": "iconUrl",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareThemeURIs",
                                                "kind": "LinkedField",
                                                "name": "square",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "light"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "dark"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "transparent"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v6/*: any*/),
            "filters": [
              "scopeId",
              "q"
            ],
            "handle": "connection",
            "key": "AggDirectoryView_teamsTql",
            "kind": "LinkedHandle",
            "name": "teamsTql"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "79c53268cc9a7d7758ab9786e27d5d6123c05a0621a6e2f9c152ab56712e835c",
    "metadata": {},
    "name": "AggDirectoryViewTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7a9856e3901c29c9045cbebc0bdc91ae";

export default node;
